'use es6';

import { useCallback, useState } from 'react';
import globalNavHeight from 'nav-meta/global-nav-height';
import { getOffsetTop } from '../utils/scroll';
import { requestIdleCallback } from '../utils/requestIdleCallback';
const NAV_BAR_HEIGHT_INT = parseInt(globalNavHeight, 10);
/**
 * @deprecated moved to marketplace-ui-common/hooks
 */

export const useHeaderTabs = (tabIds, scrollOffset) => {
  const [activeTab, setActiveTab] = useState(tabIds[0]);
  const [tabClicked, setTabClicked] = useState(false);
  const calculateActiveTab = useCallback(() => {
    const cancelCalculateCallback = requestIdleCallback(() => {
      if (!tabClicked) {
        const scrollPosition = window.scrollY + scrollOffset;

        for (let idIndex = tabIds.length - 1; idIndex > 0; idIndex--) {
          const tabId = tabIds[idIndex];
          const tabElement = document.querySelector(`#${tabId}`);

          if (tabElement && scrollPosition > getOffsetTop(tabElement)) {
            setActiveTab(tabId);
            return;
          }
        }

        setActiveTab(tabIds[0]);
      }
    }, 200);
    return () => cancelCalculateCallback();
  }, [scrollOffset, tabClicked, tabIds]);
  const scrollToTabSection = useCallback(tabId => {
    const cancelScrollCallback = requestIdleCallback(() => {
      const scrollY = getOffsetTop(document.querySelector(`#${tabId}`));

      if (scrollY) {
        window.scrollTo({
          top: scrollY - NAV_BAR_HEIGHT_INT,
          behavior: 'smooth'
        });
      }
    });
    setActiveTab(tabId);
    setTabClicked(true);
    setTimeout(() => {
      setTabClicked(false);
    }, 1000);
    return () => cancelScrollCallback();
  }, [setActiveTab, setTabClicked]);
  return {
    calculateActiveTab,
    scrollToTabSection,
    activeTab
  };
};